import { isAmplitudeUrl } from './amplitude-url';

// Reads the browser's network activity (Resource Timing), so it never touches globals other apps use.
// `buffered: true` also delivers requests made before the wrapper loaded, and the observer keeps
// receiving new entries even after the browser's resource timing buffer is full.
export const startAmplitudeMonitoring = (
  onAmplitudeRequestSent: (url: string) => void,
): void => {
  if (
    typeof PerformanceObserver === 'undefined' ||
    !PerformanceObserver.supportedEntryTypes?.includes?.('resource')
  ) {
    return;
  }

  const observer = new PerformanceObserver((entryList) => {
    entryList
      .getEntries()
      .filter((entry) => isAmplitudeUrl(entry.name))
      .forEach((entry) => onAmplitudeRequestSent(entry.name));
  });
  observer.observe({ type: 'resource', buffered: true });
};
